import React, { Component } from "react";
import "./SidePanel.css";
import PropTypes from "prop-types";

export default class SidePanel extends Component {

    render() {
        return (
            <div className="SidePanel">
                <div className="SidePanel-fixed">
                    {this.props.content}
                </div>
            </div>
        );
    }

}

SidePanel.propTypes = {
    content: PropTypes.node
}